/*

Moment.js formázások és beállítások

*/
function momentFormats() {

    let m = moment().format();

    let langCode = document.documentElement.lang.toLowerCase();
    //alert(langCode);
    $.each($('.moment-datetime'), function () {
        var originaldate = $(this).text();
        $(this).text(moment(originaldate).locale(langCode).fromNow());
    });
    //landing oldalakon a dátum badge formázása month és day
    $.each($('.year'), function () {
        var date = $(this).text();
        m = moment(date, 'YYYY-MM-DD hh:mm');
        $(this).html(m.locale(langCode).format('YYYY'));
    });
    $.each($('.month'), function () {
        var date = $(this).text();
        m = moment(date, 'YYYY-MM-DD hh:mm');
        $(this).html(m.locale(langCode).format('MMM'));
    });
    $.each($('.day'), function () {
        var date = $(this).text();
        m = moment(date, 'YYYY-MM-DD hh:mm');
        $(this).html(m.locale(langCode).format('Do'));
    });
    $.each($('.date'), function () {
        var date = $(this).text();
        m = moment(date, 'YYYY-MM-DD hh:mm');
        $(this).html(m.locale(langCode).format('YYYY. MMMM Do'));
    });
    $.each($('.datetime'), function () {
        var date = $(this).text();
        m = moment(date, 'YYYY-MM-DD hh:mm');
        $(this).html(m.locale(langCode).format('YYYY. MMMM Do, dddd'));
    });
    $.each($('.datetimehour'), function () {
        var date = $(this).text();
        m = moment(date, 'YYYY-MM-DD hh:mm');
        $(this).html(m.locale(langCode).format('YYYY. MMMM Do, H:mm '));
    });
    $.each($('.inputdate'), function () {
        var date = $(this).val();
        m = moment.unix(date).utc().format('YYYY. MM. DD.');
        $(this).val(m);
    });
    $.each($('.dateunix'), function () {
        var date = $(this).text();
        var newDate = moment.unix(date);
        $(this).text(newDate.locale(langCode).format('YYYY. MMMM Do'));
    });
    $.each($('.dateRange'), function () {
        var start = $(this).data('start');
        var end = $(this).data('end');
        var newStart = moment(start, 'YYYY. MM. DD.');
        var newEnd = moment(end, 'YYYY. MM. DD.');
        $(this).val(
            newStart.locale(langCode).format('YYYY. MMMM Do') +
            ' - ' +
            newEnd.locale(langCode).format('YYYY. MMMM Do')
        );
    });
}

let slideCounter = 0; //szükséges a sliderek id generálásához
/*
	jQuery exists() létrehozása
    használat: $.exists(selector)
*/
jQuery.exists = function (selector) {
    return $(selector).length > 0;
};

/*
	Bootstrap viewport méretek
	https://stackoverflow.com/questions/45394053/how-to-detect-screen-size-or-view-port-on-bootstrap-4-with-javascript
*/
function getViewport() {
    // https://stackoverflow.com/a/8876069
    const width = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
    );
    if (width <= 576) return 'xs';
    if (width <= 768) return 'sm';
    if (width <= 992) return 'md';
    if (width <= 1200) return 'lg';
    return 'xl';
}

function sliderBuild(cssSelector) {
    try {
        if ($.exists(cssSelector + ' .carousel')) {
            let thisCarouselId = $(cssSelector + ' .carousel').attr('id');
            //console.log($('#' + thisCarouselId));
            $.each(
                $('#' + thisCarouselId + ' .carousel-inner .carousel-item'),
                function (i, element) {
                    $(this).attr('id', 'carousel-item--' + slideCounter);
                    //console.log(this);
                    if (i == 0) {
                        $(this).addClass('active');
                        $(cssSelector + ' .carousel-indicators').append(
                            '<li data-target="#' +
                            thisCarouselId +
                            '" data-slide-to="' +
                            i +
                            '" class="active"></li>'
                        );
                    } else {
                        $(cssSelector + ' .carousel-indicators').append(
                            '<li data-target="#' +
                            thisCarouselId +
                            '" data-slide-to="' +
                            i +
                            '"></li>'
                        );
                    }
                    slideCounter = slideCounter + 1;
                }
            );
            $('#' + thisCarouselId + ' .pause').click(function () {
                //console.log(this);
                $('#' + thisCarouselId).carousel('pause');
                $(this).addClass('active');
                $('#' + thisCarouselId + ' .play').removeClass('active');
            });
            $('#' + thisCarouselId + ' .play').click(function () {
                //console.log(this);
                $('#' + thisCarouselId).carousel('cycle');
                $(this).addClass('active');
                $('#' + thisCarouselId + ' .pause').removeClass('active');
            });
        }
    } catch (error) {
        console.log('sliderBuild(): ', error);
    }
}

$(document).ready(function () {
    /*
        Sliderek inicializálása
    */
    let slideCounter = 1;
    sliderBuild('.fluid-slider');
    sliderBuild('.content-slider');
    $('.fluid-slider').carousel({
        pause: 'false',
        interval: 2,
    });
    $('.content-slider').carousel({
        pause: 'false',
        interval: 2,
    });
    /*
        Megamenu beállításai
    */
    $.each($('.nav-main .dropdown-menu'), function () {
        //1. megkapom az eredeti id-t
        let megamenuId = $(this).attr('id');
        //2. Van-e almenü
        if ($.exists('#' + megamenuId + ' .megasubmenu')) {
            //2.1 megyszerzem a legördülő menü eredeti tartalmát
            let original = $('#' + megamenuId).html();
            //2.2 az eredeti taratlom köré hozzáteszem a flexboxos szerkezetet
            $('#' + megamenuId)
                .html(
                    '<div class="d-md-flex align-items-stretch justify-content-start">' +
                    original +
                    '</div>'
                )
                .addClass('megamenu');
        }
    });

    // Moment.js formázások és beállítások meghívása
    momentFormats();
    /*
    
    Pushy menü aktiválása és beállításai
        - A #wrapper kap egy .onepage selectort, hogy a menü kitöltse a kijelzőt > erasmus.scss-ben kezelve
    
    */

    $('.pushy-link').on('click', function () {
        $('#wrapper').toggleClass('onepage');
    });

    /*
    
    ToTop gomb
        - Ha az oldal tetején vagyunk nem jelenik meg a gomb
        - Lassú scroll effect
    
    */
    $(window).scroll(function () {
        if ($(this).scrollTop() > 40) {
            $('.scrollToTop').fadeIn();
            $('.sticky-top').addClass('pinnedHeader');
        } else {
            $('.scrollToTop').fadeOut();
            $('.sticky-top').removeClass('pinnedHeader');
        }
    });
    $('.scrollToTop').click(function () {
        $('html, body').animate({scrollTop: 0}, 800);
        return false;
    });

    /*
    
    Pagenav funkció
        - pagenav.scss tartalmazza a hozzátartozó stíluselemeket
        - pagenav.phtml szükséges hozzá
        - Csak cover képpel együtt néz ki jól! (Felcsúszik kicsit a containerjéből.)
    
    */
    $(window).resize(function () {
        setPageNavHeight();
    });

    function setPageNavHeight() {
        $('#pagenav').ready(function () {
            let pageNavHeight = $('#pagenav').outerHeight();
            //console.log(pageNavHeight);
            $('#pagenav .container').css('margin-top', pageNavHeight * -1);
        });
    }

    try {
        if ($.exists('#pagenav')) {
            //setPageNavHeight();
            let viewport = getViewport();
            switch (viewport) {
                case 'xs':
                    $('#pagenav .container').css('margin-top', '-50px');
                    break;
                case 'sm':
                    $('#pagenav .container').css('margin-top', '-50px');
                    break;
                case 'md':
                    $('#pagenav .container').css('margin-top', '-50px');
                    break;
                case 'lg':
                    setPageNavHeight();
                    break;
                default:
                    setPageNavHeight();
            }
        }
    } catch (error) {
        console.log('pagenavheight', error);
    }

    /*
    
    Cookie kezelés
        - https://www.w3schools.com/js/js_cookies.asp
    
    */

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    function getCookie(cname) {
        var name = cname + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }

    /*
        Sidebar modalossá alakítása mobilon
    */

    if ($('#sidebarModal').length != 0) {
        var sidebar = $('.sidebar').clone(true);
        $('#sidebarModal .modal-body').html(sidebar);
        $('#sidebarModal .modal-body .sidebar').removeClass('d-md-block');
    }

    /*
        Newsletter submit TKA.hu alá
    */
    $('#newsletter_form').submit(function (e) {
        e.preventDefault();

        var form = $(this);

        var name = $('#newsletter_name').val().length;
        var email = $('#newsletter_email').val().length;
        var toc = $('#aszf_accept').val();

        var alertCheck = 0;
        if (name > 1) {
            alertCheck = alertCheck + 1;
        }
        if (email > 1) {
            alertCheck = alertCheck + 1;
        }
        if (toc == 'on') {
            alertCheck = alertCheck + 1;
        }

        $.ajax({
            type: 'post',
            url: 'https://tka.hu/scripts/signNewsletter.php',
            data: form.serialize(),
            success: function (response) {
                //console.log(response);
                //$("#newsletter_success").alert();
            },
        });

        if (alertCheck == 3) {
            $('#newsletter_success').removeClass('d-none');
        }
    });

    /*
        Fejléc menü aktív menüpont kijelzés – Dropdown és Megamenu kompatibilis verzió
    */
    function setActiveMenu() {
        // 1. A jelenlegi URL megtisztítása (paraméterek és hash nélkül)
        var currentUrl = window.location.href.split(/[?#]/)[0].replace(/\/$/, "");

        // 2. Összegyűjtjük az ÖSSZES linket a menün belül (főmenü és almenük is)
        var $allLinks = $('.nav-main a');
        var $bestMatchLink = null;
        var maxLength = 0;

        $allLinks.each(function () {
            var $link = $(this);
            var hrefAttr = $link.attr('href');

            // Kihagyjuk a javascript:void(0) és üres linkeket, mert azok csak nyitógombok
            if (!hrefAttr || hrefAttr.indexOf('javascript:') === 0 || hrefAttr === '#') {
                return; // folytatjuk a következő linkkel
            }

            // Almenüpont linkjének tisztítása
            var itemUrl = $link.prop('href').split(/[?#]/)[0].replace(/\/$/, "");

            // Ha pontos az egyezés, megvan a tökéletes találat
            if (currentUrl === itemUrl) {
                $bestMatchLink = $link;
                return false; // break az each-ből
            }

            // Aloldal kezelése (ha az URL a menüpont linkjével kezdődik)
            if (itemUrl && currentUrl.indexOf(itemUrl) === 0) {
                if (itemUrl.length > maxLength) {
                    maxLength = itemUrl.length;
                    $bestMatchLink = $link;
                }
            }
        });

        // 3. Aktiválás, ha találtunk egyezést
        if ($bestMatchLink) {
            // Alaphelyzetbe állítunk mindent (levesszük a korábbi aktív osztályokat)
            $('.nav-main li').removeClass('active');
            $('.nav-main .dropdown-item').removeClass('active');

            // A) Aktiváljuk a konkrét belső linket (ha az egy dropdown-item)
            if ($bestMatchLink.hasClass('dropdown-item')) {
                $bestMatchLink.addClass('active');
            }

            // B) Aktiváljuk a legfelső szintű szülő <li> elemet
            // A .closest('li.nav-main > ul > li') helyett a biztonság kedvéért
            // megkeressük a legközelebbi olyan <li>-t, ami a fő <ul> közvetlen gyereke.
            var $topLevelLi = $bestMatchLink.closest('.nav-main > ul > li');
            if ($topLevelLi.length) {
                $topLevelLi.addClass('active');
            }
        }
    }

// Futtatás a DOM betöltődése után
    setActiveMenu();


    /*
    Dokumentumtár 
    */
    $('.doq-collapse').on('click', function () {
        if ($(this).find('.fal').hasClass('fa-angle-down')) {
            $(this)
                .find('.fal')
                .removeClass('fa-angle-down')
                .addClass('fa-angle-up');
        } else {
            $(this)
                .find('.fal')
                .removeClass('fa-angle-up')
                .addClass('fa-angle-down');
        }
    });

    /*
    Target Blank kártyákra
    */
    function setBlank(id) {
        try {
            if ($.exists(id)) {
                let tar = id + ' a';
                $(tar).each(function () {
                    $(this).attr('target', '_blank');
                });
            }
        } catch (error) {
            console.log('Error catch: ' + error);
        }
    }

    //EU Ifjúság
    setBlank('#card-col-471');
    setBlank('#card-col-472');
    setBlank('#card-col-473');
    setBlank('#card-col-477');
    setBlank('#card-col-478');
    setBlank('#card-col-501');
    setBlank('#card-col-502');
    setBlank('#card-col-503');
    setBlank('#card-col-604');
    setBlank('#card-col-605');
    setBlank('#card-col-615');
    setBlank('#card-col-620');
    setBlank('#card-col-638');
    setBlank('#card-col-640');
    setBlank('#card-col-647');

    /*
        Preloaderes képeknél a jó képméretet húzzuk be
        Pl.: Blog végoldal cover
    */
    function setImageSize(id) {
        //lekérjük az aktuális viewportot
        let viewport = getViewport();
        //ez lesz az img src
        let src;
        //mekkorára vágja a micore a képet
        let cropSize;
        //ha blogos végoldal cover photot vágunk, akkor ezzel az értékkel lesz egyenlő a cropSize
        let blogCoverSize;
        //section cover
        let sectionCoverSize;
        //fluid slider: mivel itt több id van ezért végigpörgök rajtuk és tömbbe teszem őket
        let sliderId = new Array();
        /*if ($.exists('.slider-image')) {
            $('.slider-image').each(function () {
                let tempID = '#' + $(this).attr('id');
                try {
                    if ($.exists(tempID)) {
                        sliderId.push($(tempID));
                    }
                } catch (error) {}
            });
        }
        let fluidSlider;*/

        //végignézzük, hogy az egyes képtípusok milyen méretben legyenek vágva (pl.: itt kap értéket a blogCoverSize)
        switch (viewport) {
            case 'xs':
                blogCoverSize = '?w=545&h=409&m=ct&d';
                sectionCoverSize = '?w=575&h=135&m=ct&d';
                fluidSlider = '?w=576&h=240&m=ct&d';
                break;
            case 'sm':
                blogCoverSize = '?w=510&h=383&m=ct&d'; //nagyobb, mint az md, mert itt col-12 lesz col-8 helyett
                sectionCoverSize = '?w=767&h=180&m=ct&d';
                fluidSlider = '?w=767&h=320&m=ct&d';
                break;
            case 'md':
                blogCoverSize = '?w=450&h=338&m=ct&d';
                sectionCoverSize = '?w=991&h=233&m=ct&d';
                fluidSlider = '?w=960&h=400&m=ct&d';
                break;
            case 'lg':
                blogCoverSize = '?w=610&h=458&m=ct&d';
                sectionCoverSize = '?w=1199&h=282&m=ct&d';
                fluidSlider = '?w=960&h=400&m=ct&d';
                break;
            default:
                blogCoverSize = '?w=730&h=548&m=ct&d';
                sectionCoverSize = '?w=1920&h=450&m=ct&d';
                fluidSlider = '?w=960&h=400&m=ct&d';
        }
        //itt jön a magick
        try {
            if ($.exists(id)) {
                src = $(id).data('src');
                if (id === '#blogCoverPhoto') {
                    //ha blog végoldal cover
                    cropSize = blogCoverSize;
                    $(id).attr('src', src + cropSize);
                }
                if (id === '.sectionCover') {
                    $(id).css(
                        'background-image',
                        'url(' + src + sectionCoverSize + ')'
                    );
                }
                if (id === '.slider-image') {
                    //A slisderID tömbön kell végigfutnom és egyenként átírnom a képek forrását
                    $.each(sliderId, function () {
                        src = $(this).data('src');
                        $(this).css(
                            'background-image',
                            'url(' + src + fluidSlider + ')'
                        );
                    });
                }
            }
        } catch (error) {
            console.log('Error catch: ' + error);
        }
    }

    setImageSize('#blogCoverPhoto');
    setImageSize('.sectionCover');
    if ($.exists('.slider-image')) {
        let i = 0;
        $('.slider-image').each(function () {
            $(this).attr('id', 'sliderImage-' + i);
            i = i + 1;
            //console.log(this);
        });
        setImageSize('.slider-image');
    }

    function bootstrapBodyClass() {
        let viewport = getViewport();
        $('body').addClass(viewport);
        //console.log('bootstrapBodyClass: ', viewport);
    }

    bootstrapBodyClass();

    // Visszaszámláló kártya
    countDown();

    function countDown() {
        // Ha nincs érvényes visszaszámláló nem hívjuk újra önmagunkat
        $interval = false;
        // Végiglépkedünk az összes előforduló visszaszámlálón
        $('.countdown').each(function ($key, $value) {
            // Elmentjük az aktiuális elemet egy változóba
            // (JS-ben a this mindig az adott "blokkra" érvényes, így ez áthidalható)
            $this = this;
            // Kikérjük mi a céldátum ameddig vissza kell számlálni
            $deadline = $($this).attr('data-deadline');
            $countdown = Date.parse($deadline) - Date.parse(new Date());
            // Ha még nem múlt el a dátum
            if ($countdown > 0) {
                $interval = true;
            } else {
                $countdown = 0;
            }
            if ($($this).find('.years').length) {
                $($this)
                    .find('.years')
                    .html(Math.floor($countdown / (1000 * 60 * 60 * 24 * 365)));
            }
            if ($($this).find('.days').length) {
                $($this)
                    .find('.days')
                    .html(Math.floor($countdown / (1000 * 60 * 60 * 24)) % 365);
            }
            if ($($this).find('.hours').length) {
                $($this)
                    .find('.hours')
                    .html(Math.floor(($countdown / (1000 * 60 * 60)) % 24));
            }
            if ($($this).find('.minutes').length) {
                $($this)
                    .find('.minutes')
                    .html(Math.floor(($countdown / 1000 / 60) % 60));
            }
            if ($($this).find('.seconds').length) {
                $($this)
                    .find('.seconds')
                    .html(Math.floor(($countdown / 1000) % 60));
            }
            // Ha végigmentünk az összelőforduláson
            if ($key == $('.countdown').length - 1) {
                // Megvizsgáljuk, hogy kell-e újra hívni a funkciót
                if ($interval) {
                    // Ha inge újrahívunk
                    setTimeout(countDown, 1000);
                }
            }
        });
    }

    // Szerverről a kliens oldalra küldött különböző rendszer változók
    if (typeof $sys !== undefined) {
        // Ha kaptunk rendszer változókat akkor azt JSON-t objektummá alakítjuk
        if (isJsonString($sys)) {
            $sys = JSON.parse($sys);
        }
    }

    //Tooltip inicializálás
    /*$('[data-toggle="tooltip"]').tooltip({
        'html': true
    });
*/
    $('.ssptable .column--manage').addClass('btn-group');

    function convertToUrl($string, $spaceReplacement) {
        // Kisbetűssé alakítjuk
        $string = $string.toLocaleLowerCase();
        // Elvátolítjuk az ékezeteket
        $string = $string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        // Cseréljük a szóközöket
        $string = $string.replaceAll(' ', $spaceReplacement);

        // Töröljük az összes speciális karaktert
        $string = $string.replace(/[^0-9a-z_-]/gm, '');
        // Töröljük a dupla kötőjeleket
        $string = $string.replace(/--+/gm, '-');
        // Töröljük a dupla alsóvonásokat
        $string = $string.replace(/__+/gm, '_');
        // Végül visszaadjuk az eredményt
        return $string;
    }

    function isJsonString($string) {
        try {
            JSON.parse($string);
        } catch (e) {
            return false;
        }
        return true;
    }
});

////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Mobil navigációs szűrés
/**
 * @author Kark Tamás
 */

/**
 * A '#showFilterButton' parent "div" z-index értékét levettem -200ra.
 * @todo Ezt később el kell tüntetni teljesen !!!
 */
$('#showFilterButton').closest('div').css('z-index', '-200');

/**
 * 1) Megnézzük, hogy az adott html oldalon van-e '#dom-serch' id val rendelkező "div".
 * Innen tudjuk, hogy az adott oldal egy collector page. A collector page-ek en
 * pedig megjelenítjük a mobil nav menüben a szűrő gombot.
 */
function displayFilterButton() {
    if (jQuery.exists('#dom_search')) {
        $('#collector-pages-mobile-filter').removeClass('display-none');
    }
}

displayFilterButton();

/**
 * 2) A szűrő gombra kattintás:
 * 2.1) A görgetés beállításai.
 * 2.2) A sidebar helyzetének megváltoztatása, valamint  a filter gomb háttészínének megváltoztatása
 */

/**
 * 2.1)
 */

// Globális változó a görgetési pozíció tárolására
let scrollPosition = 0;

$('#collector-pages-mobile-filter').on('click', () => {
    // Ha a kattintásnál az oldal tetején vagyunk, akkor visszaállítjuk a korábbi görgetési pozíciót
    if (window.scrollY === 0) {
        window.scrollTo({
            top: scrollPosition,
            left: 0,
            behavior: 'smooth',
        });

        // Ha a kattintásnál nem az oldal legtetején vagyunk, akkor elmentjük a jelenlegi görgetési pozíciót
    } else {
        scrollPosition = window.scrollY;
        // Majd felgörgetjük az oldalt a tetejére
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
        // console.log(scrollPosition);
    }

    /**
     * 2.2) A szűrő gombra kattintva megkeressük a ".sidebar" legközelebbi ".row"
     * parent-jét, és itt cserélgetjük a  "flex-column-reverse" osztályt.
     * Valamint ugyanígy cserélgetjük a szűrő gombon a
     * 'collector-pages-mobile-filter--is-active' osztályt is.
     */
    $('.sidebar').closest('.row').toggleClass('flex-column-reverse');

    $('#collector-pages-mobile-filter').toggleClass(
        'collector-pages-mobile-filter--is-active'
    );
});

////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Scrollspy
/**
 * @author Kark Tamás
 */

/**
 * A toggleIcon segítségével bezárjuk vagy kinyitjuk az űrlap navigációs felületét.
 */
const toggle = $('.scrollspy__toggle');
toggle.click(function () {
    $('.scrollspy__body').toggleClass('scrollspy__body--closed');
    $('.scrollspy__toggle--open').toggleClass('d-none');
    $('.scrollspy__toggle--close').toggleClass('d-none');
});
